import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=2cae4e4c&lang=scss"

const __exports__ = script;

export default __exports__